<template>
  <v-container>
    <v-progress-linear v-if="isLoading" :indeterminate="true">
    </v-progress-linear>
    <FormReceivingOfCultivatedAbolone
      :ReceivingOfCultivatedAbolone="editReceivingOfCultivatedAbolone"
      :isSaving="isSaving"
      @save="save"
      @process="process"
      @cancel="$router.push({name: from.name })" />
    </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import loading from '@codehq/aurora-app-core/src/mixins/loading';
import dayjs from 'dayjs';
import FormReceivingOfCultivatedAbolone from '../components/FormReceivingOfCultivatedAbolone.vue';
import formatting from '../mixins/formatting';
import stockItem from './stockItem';

export default {
  components: {
    FormReceivingOfCultivatedAbolone,
  },
  name: 'EditReceivingOfCultivatedAbolone',
  module: 'Processing',
  mixins: [loading, formatting, stockItem],
  data() {
    return {
      /**
      * Get/Set editing ReceivingOfCultivatedAbolone. Default to {}.
      */
      editReceivingOfCultivatedAbolone: {},
      /**
       * Query Id for ReceivingOfCultivatedAbolone
       */
      receivingOfCultivatedAboloneId: this.$route?.query.id,
    };
  },
  computed: {
    /** Vuex states
     */
    ...mapState('receivingOfCultivatedAbolones', ['receivingOfCultivatedAbolones', 'receivingOfCultivatedAbolone']),
    /** Get the mode for this view, create or update
     */
    mode() {
      if (this.receivingOfCultivatedAboloneId) {
        return 'edit';
      }
      return 'add';
    },
  },
  destroyed() {
    this.$off('stockItem.loaded');
  },
  async mounted() {
    this.$on('stockItem.loaded', async (item) => {
      if (this.mode === 'add') {
        this.editReceivingOfCultivatedAbolone.stockItemId = item.id;
        this.editReceivingOfCultivatedAbolone.farm = item.deliveryNote.farm.id;
        this.editReceivingOfCultivatedAbolone.totalMassReceived = item.receivedMass;
        this.editReceivingOfCultivatedAbolone.arrivalTemperature = item.receivedTemp;
        this.$log.info('Prepop completed');
        await this.LOAD_farms();
        if (this.mode === 'edit') {
          this.isLoading = true;
          await this.LOAD_receivingOfCultivatedAbolone(this.receivingOfCultivatedAboloneId);
          this.isLoading = false;
          this.editReceivingOfCultivatedAbolone = this.receivingOfCultivatedAbolone;
        }
        this.$forceUpdate();
      } else {
        this.$log.info('No prepopulation required');
      }
    });
  },
  methods: {
    /** Vuex methods
     */
    ...mapActions('farms', ['LOAD_farms']),
    ...mapActions('receivingOfCultivatedAbolones', ['LOAD_receivingOfCultivatedAbolone', 'CREATE_receivingOfCultivatedAbolone', 'UPDATE_receivingOfCultivatedAbolone']),
    ...mapActions('stockItems', ['UPDATE_stockItem']),
    async process(receivingOfCultivatedAbolone) {
      this.isSaving = true;
      if (this.mode === 'add') {
        await this.CREATE_receivingOfCultivatedAbolone(receivingOfCultivatedAbolone);
      } else {
        await this.UPDATE_receivingOfCultivatedAbolone(receivingOfCultivatedAbolone);
      }

      const { stockItemId } = receivingOfCultivatedAbolone;
      await this.UPDATE_stockItem({
        id: stockItemId,
        state: 'Receipted',
        productionDate: dayjs(new Date()).add(1, 'day').toDate(),
      });
      this.isSaving = false;
      this.$router.push({ name: 'processing-ListStockItem' });
    },
    /** Method used to save the item
     */
    async save(receivingOfCultivatedAbolone) {
      this.isSaving = true;
      if (this.mode === 'add') {
        await this.CREATE_receivingOfCultivatedAbolone(receivingOfCultivatedAbolone);
      } else {
        await this.UPDATE_receivingOfCultivatedAbolone(receivingOfCultivatedAbolone);
      }
      this.isSaving = false;
      this.$router.push({ name: 'processing-ListVerify' });
    },
  },
};
</script>

<docs>
# EditReceivingOfCultivatedAbolone example

'''js
<EditReceivingOfCultivatedAbolone :ReceivingOfCultivatedAbolone="ReceivingOfCultivatedAbolone" />
'''
</docs>
